
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "45a39900f4b877df0cb831155f20f077ba934f67",
  "nuxt": {
    "buildId": "1c042f85-c87a-40f1-ab21-e5266a2b4df0"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
